import { render, staticRenderFns } from "./ObjectsRelocator.vue?vue&type=template&id=147095cc&"
import script from "./ObjectsRelocator.vue?vue&type=script&lang=ts&"
export * from "./ObjectsRelocator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports